import request from '../../../../setup/axios/request'

export const getListCertificate = (data: any) => {
  return request({
    url: '/api/v1/certificate/get-list-certificate',
    method: 'post',
    data: data,
  })
}

export const sellingCertificateCreate = (data: any) => {
  return request({
    url: '/api/v1/certificate/selling-certificate-create',
    method: 'post',
    data: data,
  })
}

export const deleteCertificate = (id: any) => {
  return request({
    url: '/api/v1/certificate/delete-certificate?Id=' + id,
    method: 'delete',
  })
}

export const getListCertificateManage = (data: any) => {
  return request({
    url: '/api/v1/certificate/get-list-certificate-manage',
    method: 'post',
    data: data,
  })
}

export const getCertificateBacklog = (data: any) => {
  return request({
    url: '/api/v1/certificate/get-certificate_backlog',
    method: 'post',
    data: data,
  })
}

export const sellingCertificateManageCreate = (data: any) => {
  return request({
    url: '/api/v1/certificate/selling-certificate-manage-create',
    method: 'post',
    data: data,
  })
}

export const deleteCertificateManage = (id: any) => {
  return request({
    url: '/api/v1/certificate/delete-certificate-manage?Id=' + id,
    method: 'delete',
  })
}

export const getCertificateDetailManage = (id: any) => {
  return request({
    url: '/api/v1/certificate/get-certificate-manage-detail?Id=' + id,
    method: 'get',
  })
}

export const getCertificateDetail = (id: any) => {
  return request({
    url: '/api/v1/certificate/get-certificate-detail?Id=' + id,
    method: 'get',
  })
}

export const getLogCertificate = (data: any) => {
  return request({
    url: '/api/v1/certificate/get-log-certificate',
    method: 'post',
    data: data
  })
}